@if (creation) {
  <section aria-label="Team changes progress">
    @if (creation.error) {
      <p role="alert">{{ creation.error }}</p>
    }
    @if (creation.progress; as progress) {
      <p role="status"><strong>{{ creation.progressMessage }}</strong></p>
      @if (progress.phase === 'preparing' || progress.phase === 'needs_review') {
        <p>{{ progress.preparedCount }} of {{ progress.selectedCount }} employee entries prepared. Membership has not committed.</p>
      }
      @if (progress.phase === 'team_committed' || progress.phase === 'complete') {
        <p>{{ progress.memberCount }} {{ progress.purpose === 'create' || !progress.purpose ? 'team members' : 'employees added' }}.@if (progress.purpose === 'edit_members') {
          <span> {{ progress.removedCount }} memberships removed.</span>
        }</p>
      }
      @if (progress.criteriaSaved) {
        <p>Team filters saved.</p>
      }
      @if (progress.preflight; as counts) {
        <p>{{ counts.complete ? 'Checks complete' : 'Checking employees — counts are partial' }} · {{ counts.matchingRows }} match criteria · {{ counts.eligibleRows }} eligible · {{ counts.proposedEntries }} proposed for preparation / addition</p>
        <details><summary>View account and membership checks</summary><p>{{ counts.resolvedDistinctUsers }} distinct existing accounts · {{ counts.currentMemberRows }} current member rows · {{ counts.removedMemberRows }} previously removed rows · {{ counts.blockedRows }} blocked. Matching employee rows are not a count of actual additions.</p></details>
      }
      @for (issue of progress.issues; track issue) {
        <p role="alert">{{ issue.split('_').join(' ') }}. Review this issue before resuming.</p>
      }
      @if (!creation.busy && progress.phase !== 'complete' && progress.phase !== 'closed') {
        <button mat-stroked-button (click)="creation.resume(progress.operationId)">Resume</button>
      }
      @if (!creation.busy && progress.phase !== 'complete' && progress.phase !== 'closed') {
        <button mat-button (click)="creation.close()">Close recovery (keeps prepared accounts and any team)</button>
      }
    }
    @for (operation of creation.recoverable; track operation) {
      <div>
        <span>Unfinished {{ operation.purpose === 'edit_members' ? 'membership edit' : operation.purpose === 'add_members' ? 'employee addition' : 'team creation' }} · {{ operation.preparedCount }} / {{ operation.selectedCount }} prepared</span>
        <button mat-stroked-button [disabled]="creation.busy" (click)="creation.resume(operation.operationId)">Resume</button>
      </div>
    }
  </section>
}
